module.exports = __webpack_public_path__ + "img/dreh_pic.8dbb7f00.png";